import { render, staticRenderFns } from "./NotificationForLogin.vue?vue&type=template&id=29ea9142&scoped=true&"
import script from "./NotificationForLogin.vue?vue&type=script&lang=js&"
export * from "./NotificationForLogin.vue?vue&type=script&lang=js&"
import style0 from "./NotificationForLogin.vue?vue&type=style&index=0&id=29ea9142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ea9142",
  null
  
)

export default component.exports